import { AvailableGameAction } from '../../model/AvailableGameAction';
import gameStore from '../../store/GameStore';
import playerStore from '../../store/PlayerStore';
import { WEvent } from './WEvent';

export class WBotAvailableGameActionEvent extends WEvent {
  gameId: string;
  pid: string;

  availableAction: AvailableGameAction;

  constructor(event: WBotAvailableGameActionEvent) {
    super(event.tableId, event.eventType, event.eventTime);
    Object.assign(this, event);
  }

  public applyWebsocketChanges = (): Promise<void> =>
    gameStore.findActiveGame(this.tableId).then(game => {
      playerStore.modifyPlayers(
        game.players,
        this.pid,
        player => (player.notParticipating = false),
      );
      if (game.activePid === this.pid) {
        game.setAvailableAction(this.availableAction);
      }
    });
}
